import { FC } from "react";
import { DashboardContentLayout } from "~ui-components/components/atoms/dashboard-content-layout";
import { InvoiceHistory } from "~ui-components/components/organisms/user-accounts/invoice-history";
import {
	Account,
	AccountRecurlyInvoice,
} from "~ui-components/types/__generated/gql/graphql";

export interface InvoiceProps {
	isLoading: boolean;
	account: Account;
	count: number;
	rows: AccountRecurlyInvoice[];
	page: number;
	onPageChange: (page: number) => void;
	onRowsPerPageChange: (rowsPerPage: number) => void;
	rowsPerPage: number;
	rowsPerPageOptions: number[];
}
export const Invoice: FC<InvoiceProps> = ({
	isLoading,
	account,
	count,
	rows,
	page,
	onPageChange,
	onRowsPerPageChange,
	rowsPerPage,
	rowsPerPageOptions,
}) => {
	return (
		<DashboardContentLayout pageTitle="Invoice">
			<InvoiceHistory
				isLoading={isLoading}
				tableProps={{ account, rows }}
				paginationProps={{
					page,
					count,
					onPageChange: (_, page) => onPageChange(page),
					onRowsPerPageChange: (e) =>
						onRowsPerPageChange(Number(e.target.value)),
					rowsPerPage,
					rowsPerPageOptions,
				}}
			/>
		</DashboardContentLayout>
	);
};
